import AP from "../legacy/global";
import { getGatewayUrl } from "../utils/get-api-url";

export const postPolicyNote = async (insightPolicyId, note) => {
  const data = `
    <PolicyChangeSet schemaVersion="2.1" username="${AP.u}" description="Adding a note">
      <Note>
        <Content><![CDATA[${note}]]></Content>
      </Note>
    </PolicyChangeSet>`;

  const apiUrl = getGatewayUrl("pxcentral");
  const fullUrl = `${apiUrl}/policies/${insightPolicyId}`;

  const response = await fetch(fullUrl, {
    method: "POST",
    credentials: "include",
    body: data,
    headers: {
      "Content-Type":
        "application/xml; charset=UTF-8; schema=policychangeset.2.1",
      Accept: "application/xml"
    }
  });

  const { statusText, ok } = response;
  const text = await response.text();

  if (!ok) throw new Error(text.message || statusText);

  return Promise.resolve();
};
